<script>
  import * as Tracking from "../common/tracking"
  import { notification } from '../common/notificationStore.js';

  export let userId;

  const callMeBack = () => {
    Tracking.track("website_call_me_back_clicked", { user_id: userId })
    $notification = { notice: "Merci de votre intérêt, nous allons rapidement prendre contact avec vous" }
  }
</script>

<button class="text-sm font-medium group text-primary" on:click={callMeBack}>
  Je souhaite être rappelé
  <span class="inline-block ml-1 transition-transform group-hover:translate-x-1">→</span>
</button>
